import { createGlobalStyle } from 'styled-components';

export const theme = {
  colors: {
    background: '#121212',
    primary: '#ff9900',
    secondary: '#f7931a', // BTC 颜色
    text: '#ffffff',
    inputBg: '#1e1e1e',
    buttonBg: '#f7931a',
    errorColor: '#ff5555'
  },
  fonts: {
    main: "'Roboto', sans-serif"
  },
  breakpoints: {
    mobile: '768px',
  }
};

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
  
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  body {
    font-family: ${({ theme }) => theme.fonts.main};
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
    line-height: 1.5;
    min-height: 100vh;
  }
  
  button {
    cursor: pointer;
    font-family: ${({ theme }) => theme.fonts.main};
  }
`;